<template>
  <div class="main-wrap">
    <action-bar title="消息详细"></action-bar>
    <ul class="nav">
      <li @click="goto('/home/user')">会员咨询</li>
      <li  @click="goto('/home/password')">修改密码</li>
      <li  class="active" @click="goto('/home/message')">消息中心</li>
    </ul>

    <div class="content">
      <p>{{content}}</p>
    </div>
  </div>
</template>

<script>
import ActionBar from "@/components/action-bar";
import { getNoticeDetail } from "@/service/home";
export default {
  data() {
    return {
       content: ""
    };
  },
  created() {   
     let id = this.$route.query.id;
     console.log('获取编号',id)
     let  content =  getNoticeDetail(id);
     if(content.data){
         this.content = content.data.content;
     }
  },
  methods: {
       goto(url){
           this.$router.push(url);
      }
    
  },
  components: {
    ActionBar
  }
};
</script>

<style scoped lang="less">
.main-wrap {
  .nav {
    background-color: #ffffff;
    margin: 0;
    padding: 0;
    list-style-type: none;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    font-size: 18px;
    li {
      width: 220px;
    }

    .active {
      border-bottom-color: #ba142b;
      border-bottom-width: 4px;
      color: #ba142b;
    }
  }
  .content {
    border-radius: 5px;
    margin: 20px 5px;
    height: auto;
    padding: 10px;
    background-color: #ffffff;
    font-size: 24px;
    table,
    td,
    th {
      height: 50px;
      border: 1px solid #cccccc;
      text-align: center;
      padding-top: 20px;
    }
    th {
      background-color: #eeeeee;
    }

    td .ipt-6 {
        width: 400px !important; 
        height: 50px;
        text-align: left !important;
        border: #999 1px solid;
        
    }

    .btn-bet {
        background: none repeat scroll 0 0 #e92f24;
        border: 1px solid #dc372c;
        border-radius: 4px;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        height: 52px;
        text-align: center;
        width: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/msgDetail/index.vue